<template>
  <main>
    <CollectivitesSidebar />
    <section class="app-section">
      <div class="page-space-50"></div>
      
      <div class="sidebar-icon open show-mobile mb-5" @click="toggleSidebar">
        <div class="barr1"></div>
        <div class="barr2"></div>
        <div class="barr3"></div>
      </div>

      <div id="app">
        <router-view />
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import CollectivitesSidebar from '@/components/collectivites/CollectivitesSidebar.vue'

function toggleSidebar() {
  const sidebar = document.querySelector('.sidebar')
  if (sidebar) {
    sidebar.classList.toggle('close')
  }
}

onMounted(() => {
  // Écouter les clics sur les boutons sidebar externes
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement
    if (target.closest('.sidebar-icon.open')) {
      toggleSidebar()
    }
  })
})
</script>

